import {FilterParams} from 'app/blocks/util/filter-params';
import {SortDirection} from 'app/blocks/util/sort-direction';

export interface ListViewParams {
    pageIndex: number;
    pageSize: number;
    sortColumn: string;
    sortDirection: SortDirection;
    filter: string;
    filterParams: FilterParams[] | null;
    primaryFilter?: string;
}

/**
 * Request params for the list endpoint of an entity. Shared by the store, which fetches the page on
 * screen, and by callers that need to ask for the same rows in the same order under a different page
 * size - a "select all" that reaches past the current page, for example.
 */
export function buildListApiParams(viewParams: ListViewParams, primaryFilter?: string): any {
    const params = {
        page: viewParams.pageIndex,
        size: viewParams.pageSize,
        sort: viewParams.sortColumn + ',' + viewParams.sortDirection,
        query: viewParams.filter
    };

    if (viewParams.filterParams) {
        for (const filter of viewParams.filterParams) {
            if (filter.currentValue) {
                params[filter.columnName] = filter.currentValue.toString();
            }
        }
    }

    if (primaryFilter) {
        params['primaryFilter'] = primaryFilter;
    }

    return params;
}
